namespace Gordic.Epk.WebControls.Vyrizeni {

    export class SignerUkr {

        private server = new GContent("Gordic.Epk.WebControls.Vyrizeni");

        public sign(configsToSign: Wfl.Interface.GEpkSignConfigDto[], gcontent: GContent<any>) {

            var defForeach;
            var defStart = $.Deferred();
            var defEnd = $.Deferred();

            var signContentElement = gcontent.dialogs.showModalWindow(Gordic.Wfl.WebClient.SignContent);
            var gContentWidget = signContentElement.gcontent<Gordic.Wfl.WebClient.SignContent>();

            signContentElement.on("close", (ev, obj) => {

                if (obj === "Podepsat") {
                    var signedConfigs: any[] = [];
                    this.server.call("GetListBytes", { configsToSign: configsToSign })
                        .then((EpkByteFileDto: { data: string, fileName: string, IxsUlo: string }[]) => {
                            var signer: Wfl.WebClient.UASigner = gContentWidget.signer;
                            for (var index = 0; index < EpkByteFileDto.length; index++) {
                                var prevPromise = index === 0 ? defStart : defForeach;
                                let item = EpkByteFileDto[index];                       // díky aplikaci "let" se mi nepřepisují data v then()
                                defForeach = prevPromise.then(() => {
                                    return signer.sign(item.data, item.fileName || "File", {
                                        ixsUlo: item.IxsUlo
                                    })
                                        .then((signDto) => {
                                            return signer.verify({ data: signDto.data, name: signDto.fileName, customDto: signDto.customDto })
                                        })
                                        .then((signDto) => {
                                            signedConfigs.push({
                                                data: signDto.file,
                                                fileName: signDto.fileName,
                                                IxsUlo: signDto.customDto.ixsUlo,
                                            });
                                            return $.Deferred().resolve().promise();
                                        });

                                });
                            }
                            defStart.resolve();
                            defForeach.then(() => {
                                defEnd.resolve(signedConfigs);
                            },
                                (reason) => {
                                    defEnd.reject(reason);
                                })

                        });
                }
                else {
                    var reason: IGReasonResponse = { handled: false, reason: "jres:32000459", type: EReasonType.userCancelled, operation: OperationsEnum.sign } //RC 32000459 : Podepisování bylo přerušeno.
                    defEnd.reject(reason);
                }
            })

            return defEnd.promise();

        }

    }

}